import React from "react";
import "./index.scss";

const PasswordHint = ({ className = '' }) => {

	return (
		<>
			<div className={`pass-hint-blc ${className}`}>
				<div className="hint-hd">
					Password Hint
				</div>
				<ul className="list-unstyled mb-0">
					<li>
						*must contain at least one alphabet character
					</li>
					<li>
						*must contain at least one number [0-9]
					</li>

					<li>
						*must contain at least one special character [!, @, #, $]
					</li>
					<li>
						*must be at least 8 characters in length
					</li>
				</ul>
			</div>
		</>
	);
}

export default PasswordHint;